import cn from 'classnames'
import React, { Fragment, useEffect, useState } from 'react'

import Modal from '../../modal'
import Icon from '../../tntd-icon'

import './index.less'

const Title = ({
  title,
  logo,
  fullscreen,
  supportFullscreen = true,
  onToggleFullscreen,
  onClose,
}) => {
  return (
    <Fragment>
      <div>
        {logo && <img src={logo} />}
        <span>{title}</span>
      </div>
      <div className="tnt-modal-header-actions">
        {supportFullscreen && (
          <Icon
            className="fullscreen"
            type={fullscreen ? 'fullscreen-exit' : 'fullscreen'}
            onClick={onToggleFullscreen}
          />
        )}
        <Icon className="close" type="close" onClick={onClose} />
      </div>
    </Fragment>
  )
}

export default (props) => {
  const {
    visible,
    children,
    logo,
    title,
    height = '90vh',
    width = '85%',
    className,
    supportFullscreen,
    onToggleFullscreen,
    onCancel,
    ...rest
  } = props
  const [fullscreen, setFullscreen] = useState(rest.fullscreen || false)

  useEffect(() => {
    setFullscreen(rest.fullscreen)
  }, [rest.fullscreen, visible])

  return (
    <Modal
      visible={visible}
      title={
        <Title
          logo={logo}
          title={title}
          fullscreen={fullscreen}
          supportFullscreen={supportFullscreen}
          onClose={onCancel}
          onToggleFullscreen={() => {
            setFullscreen(!fullscreen)
            onToggleFullscreen && onToggleFullscreen(!fullscreen)
          }}
        />
      }
      onCancel={onCancel}
      destroyOnClose
      centered
      footer={null}
      width={fullscreen ? '100%' : width}
      style={{
        height: fullscreen ? '100vh' : height,
      }}
      className={cn('tnt-modal', { [className]: className, fullscreen })}
      {...rest}
    >
      {children}
    </Modal>
  )
}
